import {
    DELETE_CLIP_REQUEST_OPEN_MODAL,
    DELETE_CLIP_REQUEST_REQUEST,
    DELETE_CLIP_REQUEST_RESULT,
} from 'Redux/actionTypes';

export const deleteClipRequestOpenModal = (data) => ({
    type: DELETE_CLIP_REQUEST_OPEN_MODAL,
    payload: data
})

export const deleteClipRequestRequest = (data) => ({
    type: DELETE_CLIP_REQUEST_REQUEST,
    payload: data
})

export const deleteClipRequestResult = (data) => ({
    type: DELETE_CLIP_REQUEST_RESULT,
    payload: data
})